import { useEffect, useState } from "react";
import { CalendarDays, Clock, MapPin, User } from "lucide-react";
import axios, { API } from "@/lib/api";
import StatusBadge from "@/components/shared/StatusBadge";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

function formatDate(d) { return d ? new Date(d).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : "-"; }

export default function JamaahManasik() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    axios.get(`${API}/jamaah/manasik`).then(({ data }) => setEvents(data)).catch(() => setEvents([]));
  }, []);

  return (
    <div data-testid="jamaah-manasik-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Jadwal Manasik</h1>
        <p className="text-sm text-[#64748B]">Ikuti jadwal manasik untuk program Anda.</p>
      </div>

      {events === null ? <LoadingScreen /> : events.length === 0 ? (
        <EmptyState icon={CalendarDays} title="Belum ada jadwal manasik" description="Jadwal manasik akan tampil setelah program Anda dikonfirmasi." />
      ) : (
        <div className="space-y-4">
          {events.map((e) => (
            <div key={e.id} data-testid={`jamaah-manasik-item-${e.id}`} className="rounded-2xl bg-white p-5 shadow-[0_2px_10px_rgba(15,107,79,0.05)]">
              <div className="flex flex-wrap items-start justify-between gap-2">
                <h3 className="font-heading text-base font-semibold text-[#1F2937]">{e.title}</h3>
                <div className="flex gap-2">
                  <StatusBadge status={e.status} />
                  {e.my_attendance && <StatusBadge status={e.my_attendance === "hadir" ? "verified" : e.my_attendance === "izin" ? "pending" : "rejected"} testId={`jamaah-manasik-attendance-${e.id}`} />}
                </div>
              </div>
              <div className="mt-3 grid grid-cols-1 gap-2 text-sm text-[#64748B] sm:grid-cols-2">
                <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4" /> {formatDate(e.date)}</p>
                <p className="flex items-center gap-2"><Clock className="h-4 w-4" /> {e.time}</p>
                <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {e.location}</p>
                {e.guide_name && <p className="flex items-center gap-2"><User className="h-4 w-4" /> {e.guide_name}</p>}
              </div>
              <p className="mt-2 text-sm text-[#1F2937]">{e.material}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
